import { DialogService } from '@shared/services/dialog-service';
import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { FlowChartDataService } from '@features/data-survey/services/flow-chart-data.service';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { EliteFormFlowChartDataService } from '@features/elite-form/services/elite-form-flow-chart-data.service';
import { EliteFormPageModel } from '@features/elite-form/models/elite-form-common-data-models';
import { PlatformCommand } from '@shared/commands/command-base';
import { CommandService } from '@core/services/command.service';
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'app-elite-form-pages-container',
  templateUrl: './elite-form-pages-container.component.html',
  styleUrls: ['./elite-form-pages-container.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EliteFormPagesContainerComponent implements OnInit, OnDestroy {
  @Input() pageModel: EliteFormPageModel;
  @Input() totalPage: any;
  @Input() questions: any;
  @Input() flowchartSection: any;
  unSubscribe$ = new Subject<void>();
  sections: any[] = [];
  flowchartId: string;
  constructor(private flowChartDataService: FlowChartDataService,
    private dialogService: DialogService,
    private platformQueryService: PlatformQueryService,
    private commandService: CommandService,
    private eliteFormFlowChartDataService: EliteFormFlowChartDataService) { }

  ngOnInit(): void {
    this.flowchartId = this.flowChartDataService.flowchartId;
    // this.setFlowchartSections();
  }
  upSection() {
    this.eliteFormFlowChartDataService.pageUpDownCommnadExecute(this.pageModel.eliteFormId, this.pageModel.id, true).pipe(takeUntil(this.unSubscribe$)).subscribe(o => {
      this.eliteFormFlowChartDataService.refreshPages();
    });
  }

  downSection() {
    this.eliteFormFlowChartDataService.pageUpDownCommnadExecute(this.pageModel.eliteFormId, this.pageModel.id, false).pipe(takeUntil(this.unSubscribe$)).subscribe(o => {
      this.eliteFormFlowChartDataService.refreshPages();
    });
  }

  addGroup() {
    this.eliteFormFlowChartDataService.addGroup(this.pageModel.id).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      this.pageModel = response.fieldValues['PageModel'];
      this.setFlowchartSections();
    });
  }

  renamePage() {
    const renameCommand = new PlatformCommand('EditEliteFormPageCommand', this.eliteFormFlowChartDataService.getApi());
    renameCommand.fieldValues['EliteFormPageId'] = this.pageModel.id;
    renameCommand.fieldValues['FlowchartSectionId'] = this.flowchartSection.id;
    renameCommand.fieldValues['SchemaId'] = this.eliteFormFlowChartDataService.schemaId;
    renameCommand.fieldValues['IsClientSchema'] = this.eliteFormFlowChartDataService.isClientSchema;
    this.commandService.executePlatformCommand(renameCommand).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      this.eliteFormFlowChartDataService.refreshPages();
    });
  }
  getPageFlowchartSections(allSections: any[], pageModel: any) {
    let pageModelSections = pageModel.flowchartSections;
    pageModelSections.sort((a, b) => a.order - b.order);
    const flowchartSections = [];
    pageModelSections.forEach(item => {
      const pageSection = allSections.find(o => o.id === item.flowchartSectionId);
      if (pageSection) {
        flowchartSections.push(pageSection);
      }
    })
    return flowchartSections;
  }

  deletePage() {
    this.dialogService.showYesNoDialog('Delete Page', 'Are you sure you want to delete this page?')
      .subscribe(response => {
        if (response && response.action === 'OK') {
          this.eliteFormFlowChartDataService.deletePageCommandExecute(this.pageModel.eliteFormId, this.pageModel.id, this.flowchartSection.id).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
            this.eliteFormFlowChartDataService.refreshPages();
          })
        }
      });
  }
  private setFlowchartSections() {
    this.flowChartDataService.getFlowchartSectionsByFlowchartId().then(response => {
      this.sections = this.getPageFlowchartSections(response, this.pageModel);
      console.log('this.sections response ===================================================> ');
      console.log(response);
    });
  }



  refreshPage($event) {
    this.setFlowchartSections();
  }

  ngOnDestroy(): void {
  }
}
